export interface IQuery { }

export class BrandingQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.OrganizationUnits.Queries.BrandingQueryV1, TCh.Domain.Organizations'

	OrganizationUnitId: number

	constructor (organizationUnitId: number)
	{
		this.OrganizationUnitId = organizationUnitId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.OrganizationUnits.Queries.BrandingQueryV1, TCh.Domain.Organizations'
	}

}

export class InstanceSetupQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.OrganizationUnits.Queries.InstanceSetupQueryV1, TCh.Domain.Organizations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.OrganizationUnits.Queries.InstanceSetupQueryV1, TCh.Domain.Organizations'
	}

}

export class OrganizationAdminDetailsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationAdminDetailsQueryV1, TCh.Domain.Organizations'

	TenantId: number

	constructor (tenantId: number)
	{
		this.TenantId = tenantId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationAdminDetailsQueryV1, TCh.Domain.Organizations'
	}

}

export class OrganizationUnitQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationUnitQueryV1, TCh.Domain.Organizations'

	OrganizationUnitId: number

	constructor (organizationUnitId: number)
	{
		this.OrganizationUnitId = organizationUnitId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationUnitQueryV1, TCh.Domain.Organizations'
	}

}

export class OrganizationUnitsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationUnitsQueryV1, TCh.Domain.Organizations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationUnitsQueryV1, TCh.Domain.Organizations'
	}

}

export class SearchOrganizationUnitQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.OrganizationUnits.Queries.SearchOrganizationUnitQueryV1, TCh.Domain.Organizations'

	OrganizationUnitId: number
	SearchPhrase: string

	constructor (organizationUnitId: number, searchPhrase: string)
	{
		this.OrganizationUnitId = organizationUnitId
		this.SearchPhrase = searchPhrase
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.OrganizationUnits.Queries.SearchOrganizationUnitQueryV1, TCh.Domain.Organizations'
	}

}

export class SsoConfigurationQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.OrganizationUnits.Queries.SsoConfigurationQueryV1, TCh.Domain.Organizations'

	TenantId: number

	constructor (tenantId: number)
	{
		this.TenantId = tenantId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.OrganizationUnits.Queries.SsoConfigurationQueryV1, TCh.Domain.Organizations'
	}

}

export class SystemStatsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Organizations.OrganizationUnits.Queries.SystemStatsQueryV1, TCh.Domain.Organizations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Organizations.OrganizationUnits.Queries.SystemStatsQueryV1, TCh.Domain.Organizations'
	}

}

